<template>
<div class="reset-container">
    <form id="reset" v-on:submit.prevent="reset()" novalidate="true">
        Upišite novu lozinku
        <div class="form-field">
            <input type="password" v-model="newPassword" v-on:change="validatePassword">
            <label for="password" v-bind:class="newPassword ? 'field-filled' : ''">Nova lozinka</label>
            <div class="error" v-bind:style="{display: isPasswordValid ? 'none' : 'block'}">Lozinka nije valjana. Mora imati bar 8 znakova, jedno veliko slovo i jedan broj.</div>
        </div>
        <div class="form-field">
            <input id="repeatedpassword" type="password" v-model="repeatedNewPassword" v-on:change="validateRepeatedPassword" />
            <label for="repeatedpassword" v-bind:class="repeatedNewPassword ? 'field-filled' : ''">Ponovljena nova lozinka</label>
            <div class="error" v-bind:style="{visibility: isRepeatedPasswordValid ? 'hidden' : 'visible'}">Upisane lozinke se ne poklapaju.</div>
        </div>
        <button type="submit" class="button" value="submit" v-bind:disabled="!isFormValid()">SPREMI</button>
    </form>
    <div class="result" v-if="isResetOver">
        <div class="you-made-it" v-if="didResetSucceed">Lozinka je uspješno promijenjena.</div>
        <div class="error" v-else>
            Niste uspjeli resetirati lozinku.
            Molimo pokušajte ponovo, ili nas kontaktirajte na <a href="mailto:days@dump.hr">e-mail</a>.
        </div>
    </div>
    <a href="/" class="return-home">Povratak na početnu &#10230;</a>
</div>
</template>

<script>
export default {
  name: "Reset",
  data() {
    return {
      didResetSucceed: false,
      isResetOver: false,
      newPassword: "",
      repeatedNewPassword: "",
      isPasswordValid: true,
      isRepeatedPasswordValid: true
    };
  },
  methods: {
    validatePassword: function() {
        let pass = this.newPassword;
        this.isPasswordValid = pass && pass.length >= 8 && pass.toLowerCase() !== pass && /\d/.test(pass);
    },
    validateRepeatedPassword: function() {
        this.isRepeatedPasswordValid = this.newPassword === this.repeatedNewPassword;
    },
    isFormValid: function() {
        return this.isPasswordValid && this.isRepeatedPasswordValid;
    },
    reset: function() {
        if(this.isFormValid() && this.newPassword === this.repeatedNewPassword)
            this.$axios.post(`${this.$API_URL}/user/reset-password`, {
                code: this.$route.query.code,
                newPassword: this.newPassword
            })
            .then(() => {
                this.didResetSucceed = true;
                this.isResetOver = true;
            })
            // eslint-disable-next-line
            .catch(error => {
                this.didResetSucceed = false;
                this.isResetOver = true;
            });
    }
  }
};
</script>

<style scoped>
.return-home {
  text-decoration: none;
  color: #30cec1;
  font-size: 24px;
}

.you-made-it {
  color: #1d9b90;
}

input,
select {
    margin-top: 20px;
    border: none;
    background-color: #f9f9f9;
    border-bottom: 2px solid black;
    font-size: 20px;
    padding: 18px 0 5px 20px;
    width: 100%;
    outline: none;
}

input[type=checkbox] {
    width: auto;
}

select {
    appearance: none;
}

form {
    max-width: 300px;
}

form > div {
    position: relative;
}

form > div.form-field > label {
    position: absolute;
    font-size: 16px;
    left: 20px;
    top: 34px;
    opacity: 0.7;
}

form > div.form-field input:focus + label,
form > div.form-field select + label,
form > div.form-field > label.field-filled {
    font-size: 14px;
    top: 22px;
    opacity: 0.6;
}

input:focus,
select:focus {
    border-bottom-color: #30cec1;
}

#reset div.checkbox {
    margin-top: 5px;
    flex-basis: 80%;
}

#reset div.checkbox input {
    margin-right: 10px;
}

.button {
    margin-top: 20px;
    margin-left: auto;
}

.reset-container {
    position: absolute;
    top: 30%;
    left: 40%;
}

@media screen and (max-width: 950px) {
    .reset-container {
        left: 30%;
    }
}

@media screen and (max-width: 600px) {
    .reset-container {
        left: 20%;
    }
}

@media screen and (max-width: 450px) {
    .reset-container {
        left: 10%;
    }
}

@media screen and (max-width: 350px) {
    .reset-container {
        left: 20px;
    }
}
</style>